import { render, staticRenderFns } from "./dialog-verification-code.vue?vue&type=template&id=574dd1cf&scoped=true&"
import script from "./dialog-verification-code.vue?vue&type=script&lang=js&"
export * from "./dialog-verification-code.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574dd1cf",
  null
  
)

export default component.exports